// extracted by mini-css-extract-plugin
export var errorsContainer = "_vj-1";
export var link = "_vj-0";